import { take, takeLatest } from "redux-saga/effects";
import { Creators as AllCreators, Types as AllTypes } from "../../actions";
import {
  IPatchCourseAction,
  PATCH_COURSE_ADD_LIST_ITEM,
  PATCH_COURSE_ADD_ORDER_ITEM,
  PATCH_COURSE_CHANGE_LIST_ITEM_ANSWERS,
  PATCH_COURSE_CHOOSE_SINGLE_CHOICE_ANSWER,
  PATCH_COURSE_DELETE_IMMERSIVE_BACKGROUND_IMAGE,
  PATCH_COURSE_IMPORT_TRANSLATIONS_CSV,
  PATCH_COURSE_SORT_COLUMN,
  PATCH_COURSE_SORT_PART,
} from "../../actions/course-author/common";
import * as CourseAuthorAction from "../../actions/course-author/course-author";
import * as authorSagas from "../../actions/course-author/course-author.sagas";
import {
  addListItemAsync,
  addOrderItemAsync,
  changeListItemAnswersAsync,
  chooseSingleChoiceAnswerAsync,
  importTranslationsCsvAsync,
  simplePatchCourse,
  sortColumn,
  sortPartAsync,
} from "../../actions/course-author/patch-course";
import {
  addImmersiveBackground,
  cloneCourse,
  createStyle,
  deleteImmersiveBackground,
  fetchCourseChanges,
  fetchFullCourse,
  migrateContentToHtml,
  patchCourse,
  patchCoursePlayer,
  patchStyle,
  resolveAuxiliaryCourseData,
  updateFullCourseData,
} from "../../actions/course-author/patches";
import * as actions from "../../actions/organizations";
import { Action } from "../../actions/types";

export const Creators = (AllCreators as any).App.CourseAuthor;
export const Types = (AllTypes as any)._APP._COURSE_AUTHOR;

export function* watchFetchCourse() {
  yield takeLatest(
    Types.FETCH_COURSE,
    fetchFullCourse({
      onFailure: Creators.handleFetchCourseFailure,
      onSuccess: Creators.handleFetchCourseSuccess,
    })
  );
}

export function* watchFetchAllOrganizations() {
  yield takeLatest(
    Types.FETCH_ALL_ORGANIZATIONS,
    actions.fetchAllOrganizations({
      onFailure: Creators.handleFetchAllOrganizationsFailure,
      onSuccess: Creators.handleFetchAllOrganizationsSuccess,
    })
  );
}

export function* watchFetchAdministrableOrgIds() {
  yield takeLatest(
    Action.LOAD_ADMINISTRABLE_ORG_IDS,
    actions.fetchAdministrableOrgIds({
      onFailure: actions.handleLoadAdministrableOrdIdsFailure,
      onSuccess: actions.handleLoadAdministrableOrdIdsSuccess,
    })
  );
}

export function* watchFetchAdministrableOrgs() {
  yield takeLatest(
    CourseAuthorAction.FETCH_ADMINISTRABLE_ORGS,
    authorSagas.fetchAdministableOrgs({
      onFailure: CourseAuthorAction.handleAdministableOrgsFailure,
      onSuccess: CourseAuthorAction.handleAdministableOrgsSuccess,
    })
  );
}

export function* watchResolveAuxiliaryData() {
  yield takeLatest(
    Types.RESOLVE_AUXILIARY_DATA,
    resolveAuxiliaryCourseData({
      onFailure: Creators.handleResolveAuxiliaryFailure,
      onSuccess: Creators.handleResolveAuxiliarySuccess,
    })
  );
}

export function* watchFetchCourseChanges() {
  yield takeLatest(
    Types.FETCH_COURSE_CHANGES,
    fetchCourseChanges({
      onFailure: Creators.handleFetchCourseChangesFailure,
      onSuccess: Creators.handleFetchCourseChangesSuccess,
    })
  );
}
export function* watchPatchCourse() {
  yield takeLatest(
    Types.PATCH_COURSE,
    patchCourse({
      onFailure: Creators.handlePatchCourseFailure,
      onSuccess: Creators.handlePatchCourseSuccess,
    })
  );
}
export function* watchSimplePatchCourse() {
  yield takeLatest(
    Types.SIMPLE_PATCH_COURSE,
    simplePatchCourse({
      onFailure: Creators.handlePatchCourseFailure,
      onSuccess: Creators.handlePatchCourseSuccess,
    })
  );
}
export function* watchCreateStyle() {
  yield takeLatest(
    Types.CREATE_STYLE,
    createStyle({
      onFailure: Creators.handleFileUploadFailure,
      onSuccess: Creators.handleFileUploadSuccess,
    })
  );
}
export function* watchPatchStyle() {
  yield takeLatest(
    Types.PATCH_STYLE,
    patchStyle({
      onFailure: Creators.handleFileUploadFailure,
      onSuccess: Creators.handleFileUploadSuccess,
    })
  );
}

export function* watchUpdateFullCourse() {
  yield takeLatest(
    Types.UPDATE_FULL_COURSE,
    updateFullCourseData({
      fetchCourse: {
        onSuccess: CourseAuthorAction.handleFetchFullCourseSuccess,
      },
      onFailure: Creators.handleUpdateFullCourseFailure,
      onSuccess: Creators.handleUpdateFullCourseSuccess,
    })
  );
}

export function* watchAddImmersiveBackground() {
  yield takeLatest(
    Types.ADD_IMMERSIVE_BACKGROUND,
    addImmersiveBackground({
      onFailure: Creators.handleAddImmBgFailure,
      onSuccess: Creators.handleAddImmBgSuccess,
      patchCourse: {
        onFailure: Creators.handlePatchCourseFailure,
        onSuccess: Creators.handlePatchCourseSuccess,
      },
    })
  );
}

export function* watchDeleteImmersiveBackground() {
  yield takeLatest<IPatchCourseAction>(
    PATCH_COURSE_DELETE_IMMERSIVE_BACKGROUND_IMAGE,
    deleteImmersiveBackground({
      onFailure: Creators.handleAddImmBgFailure,
      onSuccess: Creators.handleAddImmBgSuccess,
      patchCourse: {
        onFailure: Creators.handlePatchCourseFailure,
        onSuccess: Creators.handlePatchCourseSuccess,
      },
    })
  );
}

export function* watchPatchCoursePlayer() {
  yield takeLatest(
    Types.PATCH_COURSE_PLAYER,
    patchCoursePlayer({
      onFailure: Creators.handlePatchCoursePlayerFailure,
      onSuccess: Creators.handlePatchCoursePlayerSuccess,
      patchCourse: {
        onFailure: Creators.handlePatchCourseFailure,
        onSuccess: Creators.handlePatchCourseSuccess,
      },
      patchStyle: {
        onFailure: Creators.handleFileUploadFailure,
        onSuccess: Creators.handleFileUploadSuccess,
      },
    })
  );
}

export function* watchCloneCourse() {
  yield takeLatest(
    Types.CLONE_COURSE,
    cloneCourse({
      onFailure: Creators.handleCloneCourseFailure,
      onSuccess: Creators.handleCloneCourseSuccess,
      patchStyleFurtherActions: {
        onFailure: Creators.handleAddImmBgFailure,
        onSuccess: Creators.handleAddImmBgSuccess,
        patchCourse: {
          onFailure: Creators.handlePatchCourseFailure,
          onSuccess: Creators.handlePatchCourseSuccess,
        },
        patchStyle: {
          onFailure: Creators.handleFileUploadFailure,
          onSuccess: Creators.handleFileUploadSuccess,
        },
      },
    })
  );
}

export function* watchMigrateContentToHtml() {
  yield takeLatest(
    Types.MIGRATE_CONTENT_TO_HTML,
    migrateContentToHtml({
      onFailure: Creators.handleMigrateContentToHtmlFailure,
      onSuccess: Creators.handleMigrateContentToHtmlSuccess,
    })
  );
}

export function* watchSortPart() {
  yield takeLatest<IPatchCourseAction>(PATCH_COURSE_SORT_PART, sortPartAsync);
}

export function* watchSortColumnPosition() {
  yield takeLatest<IPatchCourseAction>(PATCH_COURSE_SORT_COLUMN, sortColumn);
}

export function* watchAddListItem() {
  yield takeLatest<IPatchCourseAction>(PATCH_COURSE_ADD_LIST_ITEM, addListItemAsync);
}

export function* watchChangeListItemAnswers() {
  yield takeLatest<IPatchCourseAction>(PATCH_COURSE_CHANGE_LIST_ITEM_ANSWERS, changeListItemAnswersAsync);
}

export function* watchChooseSingleChoiceQuestionAnswer() {
  yield takeLatest<IPatchCourseAction>(PATCH_COURSE_CHOOSE_SINGLE_CHOICE_ANSWER, chooseSingleChoiceAnswerAsync);
}

export function* watchAddOrderItem() {
  yield takeLatest<IPatchCourseAction>(PATCH_COURSE_ADD_ORDER_ITEM, addOrderItemAsync);
}

export function* watchRequestPreviewCourseInst() {
  yield takeLatest(
    CourseAuthorAction.REQUEST_PREVIEW_COURSE_INST,
    authorSagas.requestPreviewCourseInst({
      onFailure: CourseAuthorAction.handleRequestPreviewCourseInstFailure,
      onSuccess: CourseAuthorAction.handleRequestPreviewCourseInstSuccess,
    })
  );
}

export function* watchImportTranslationsCsv() {
  yield takeLatest<IPatchCourseAction>(PATCH_COURSE_IMPORT_TRANSLATIONS_CSV, importTranslationsCsvAsync);
}

export function* watchMount() {
  yield take(Types.MOUNT);
}

export function* watchUnmount() {
  yield take(Types.UNMOUNT);
}
